import { apiFetch } from '@ami/react/core';
import { ProductOptionFilter } from '../products/productOptionFilter';

const _baseEndPoint = 'product-options';

export const OptionType = Object.freeze({
  SupplierOption: 'Supplier Option',
  AMICustomization: 'AMI Customization',
});

export class ProductOptionSearchItem {
  constructor(json) {
    Object.keys(json).forEach((key) => (this[key] = json[key]));
  }
}

export class ProductOptionTag {
  constructor(json) {
    if (json) {
      this.tag = json.tag;
      return;
    }
    this.tag = '';
  }

  static search(tag) {
    var apiUrl = `${_baseEndPoint}/tags`;
    if (tag && tag !== null) {
      apiUrl = `${apiUrl}?tag=${tag}`;
    }

    return apiFetch(apiUrl).then((items) =>
      items.map((x) => new ProductOptionTag(x))
    );
  }
}

export class ProductOption {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.publicName = item.publicName;
      this.description = item.description;
      this.installationOptionId = item.installationOptionId;
      this.partNumber = item.partNumber;
      this.associatedManufacturers = item.associatedManufacturers;
      this.tags = item.tags;
      this.type = item.type;
      this.overrideCouplerManufacturingDataType =
        item.overrideCouplerManufacturingDataType;
      this.brandId = item.brandId;
      this.seriesId = item.seriesId;
      this.basePrice = item.basePrice;
      this.unitPrice = item.unitPrice;
      this.imageKey = item.imageKey;
      this.imageUrl = item.imageUrl;
      this.imageVisibility = item.imageVisibility;
      this.supplierLeadTimeId = item.supplierLeadTimeId;
      this.partNumberLogic = item.partNumberLogic;
      this.standaloneItem = item.standaloneItem;
      this.supportsFastTrackLeadTimes = item.supportsFastTrackLeadTimes;
      return;
    }
    this.id = null;
    this.name = '';
    this.publicName = '';
    this.description = '';
    this.installationOptionId = null;
    this.partNumber = '';
    this.associatedManufacturers = [];
    this.tags = [];
    this.type = null;
    this.overrideCouplerManufacturingDataType = null;
    this.brandId = null;
    this.seriesId = null;
    this.basePrice = 0;
    this.unitPrice = 0;
    this.imageKey = '';
    this.imageUrl = '';
    this.imageVisibility = 'Configuration';
    this.supplierLeadTimeId = null;
    this.partNumberLogic = null;
    this.standaloneItem = false;
    this.supportsFastTrackLeadTimes = false;
  }

  static search(filter = new ProductOptionFilter(), page) {
    filter.setPaginationParameters(page);
    return apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`).then(
      (items) => items.map((x) => new ProductOptionSearchItem(x))
    );
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new ProductOption(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  static getOptionTypes() {
    return apiFetch(`${_baseEndPoint}/option-types`);
  }

  static getProductOptionPartNumberLogics() {
    return apiFetch(`${_baseEndPoint}/product-option-part-number-logics`);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}
